import { useDispatch } from 'react-redux'
import { useCancelToken } from 'utils/hooks/useCancelToken'

import {
  actionGetWallets,
  actionGetWalletTransactions,
  actionResetTransactions,
  actionResetWallets,
  actionSetActiveWalletID,
  actionSetWalletName,
} from 'modules/Finance/Wallets/store/actions'
import { useCallback } from 'react'

export const useWallets = () => {
  const dispatch = useDispatch()
  const { cancelableDispatch } = useCancelToken()

  const getWallets = useCallback(() => dispatch(actionGetWallets()), [])

  const setActiveWalletID = useCallback((props) => dispatch(actionSetActiveWalletID(props)), [])

  const getWalletTransactions = useCallback(
    (props) => cancelableDispatch(actionGetWalletTransactions(props)),
    [],
  )

  const resetWallets = useCallback(() => dispatch(actionResetWallets()), [])

  const resetTransactions = useCallback(() => dispatch(actionResetTransactions()), [])

  const setWalletName = useCallback((props) => dispatch(actionSetWalletName(props)), [])

  return {
    getWallets,
    setActiveWalletID,
    getWalletTransactions,
    resetWallets,
    resetTransactions,
    setWalletName,
  }
}
